import React, { useState } from 'react';

import { documentTypesAbbreviationsObject } from '../../../../../store/catalogs/documentTypes';
import { iso3166CountriesLabelsObject } from '../../../../../store/catalogs/ISO3166Countries';
import { personTypesLabelsObject } from '../../../../../store/catalogs/personTypes';
import { ReactComponent as Trash } from '../../../../../assets/icons/Trash.svg';
import { ReactComponent as CircleAdmiration } from '../../../../../assets/icons/CircleAdmiration.svg';
import { ReactComponent as PSE } from '../../../../../assets/icons/PSE.svg';
import Button from '../../../../Buttons/Button/Button';
import FieldBold from '../../../../Fields/FieldBold/FieldBold';

import classes from './DeletePSEAccount.module.scss';

const DeletePSEAccount = ({ account, onClickDelete, pseBanks }) => {
  const [view, setView] = useState(0);

  const backViewDetail = () => {
    setView(0);
  };

  const pseBanksObject = pseBanks.reduce((prev, { value, label }) => ({ ...prev, [value]: label }), {});

  const askDelete = () => {
    setView(1);
  };
  return (
    <div>
      {view === 0 ? (
        <div>
          {' '}
          <span className='bold-20'>Detalles de cuenta PSE</span>
          <div className={classes.fields}>
            <FieldBold title='NOMBRE DEL TITULAR' value={account.name} />
            <FieldBold title='NATURALEZA JURÍDICA' value={personTypesLabelsObject[account.typeOfPerson]} />
            <FieldBold
              title='IDENTIFICACIÓN'
              value={`${documentTypesAbbreviationsObject[account.identificationType]} ${account.identificationNumber}`}
            />
            <FieldBold title='CORREO ELECTRÓNICO' value={account.email} />
            <FieldBold title='TELÉFONO CELULAR' value={account.phone} />
            <FieldBold title='PAÍS' value={iso3166CountriesLabelsObject[account.country]} />
            <FieldBold title='DIRECCIÓN' value={account.address} />
            <FieldBold title='BANCO' value={pseBanksObject[account.moviiBankCode]} />
          </div>
          <div className={classes.button}>
            <Button onClick={askDelete} custom='quaternary' color='gray' Icon={Trash}>
              Eliminar cuenta
            </Button>
          </div>
        </div>
      ) : (
        <div className={classes.content}>
          <CircleAdmiration />
          <span className={`bold-20 ${classes.center}`}>¿Seguro quieres eliminar esta cuenta?</span>
          <div className={classes.card}>
            <PSE />
            <div className={classes.text}>
              <span>{account.name}</span>
              <span>
                {documentTypesAbbreviationsObject[account.identificationType]} {account.identificationNumber}
              </span>
            </div>
          </div>
          <span className={`${classes.color} ${classes.center} medium-16`}>
            Esta acción es irreversible, y deberás agregar la cuenta nuevamente.
          </span>
          <div className={classes.buttons}>
            <Button onClick={backViewDetail} custom='secondary'>
              No, regresar
            </Button>
            <Button onClick={onClickDelete}>Eliminar</Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default DeletePSEAccount;
